import React, { createContext, PropsWithChildren, useContext } from 'react';
import { Orientation } from 'hooks/useOrientation';

/**
 * Allows parent components to force a specific orientation for all children.
 * Used by MultiTableGrid to force portrait mode on each table cell.
 * When null, the real viewport orientation is used.
 */
const OrientationOverrideContext = createContext<Orientation | null>(null);

export const useOrientationOverride = () => useContext(OrientationOverrideContext);

export const OrientationOverrideProvider = ({
  orientation,
  children
}: PropsWithChildren<{ orientation: Orientation }>) => {
  return (
    <OrientationOverrideContext.Provider value={orientation}>
      {children}
    </OrientationOverrideContext.Provider>
  );
};

export default OrientationOverrideContext;
